const methodologySteps = [
    {
      step: 1,
      title: 'Reconnaissance',
      description:
        "We gather intelligence about your organization's digital footprint, identifying potential entry points and attack surfaces.",
      bullets: ['OSINT Gathering', 'Asset Discovery', 'Technology Profiling'],
    },
    {
      step: 2,
      title: 'Exploitation',
      description:
        'We ethically exploit identified vulnerabilities to demonstrate real-world impact and risk.',
      bullets: ['Vulnerability Exploitation', 'Access Control Bypass', 'Post-Exploitation Activities'],
    },
    {
      step: 3,
      title: 'Reporting',
      description:
        'We deliver comprehensive reports with clear remediation steps and executive summaries.',
      bullets: ['Detailed Findings', 'Risk Prioritization', 'Remediation Guidance'],
    },
  ];
  
  export default function RedTeamMethodology() {
    return (
      <section className="bg-[#111] text-white py-20 px-6 md:px-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold">
            Our Red Team <span className="text-red-500">Methodology</span>
          </h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            We follow a systematic approach to identify vulnerabilities and provide actionable remediation strategies.
          </p>
        </div>
  
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {methodologySteps.map((step) => (
            <div
              key={step.step}
              className="bg-black border border-gray-700 rounded-lg p-6 relative hover:shadow-lg transition duration-300"
              data-aos="fade-up"
              data-aos-delay={(step.step - 1) * 150}
              data-aos-duration="800"
            >
              <div className="absolute -top-4 left-6 bg-red-600 text-white font-bold w-8 h-8 flex items-center justify-center rounded-full shadow-lg text-sm">
                {step.step}
              </div>
              <h3 className="text-lg font-semibold mb-2 mt-4">{step.title}</h3>
              <p className="text-gray-400 text-sm mb-4">{step.description}</p>
              <ul className="text-sm text-gray-300 space-y-1">
                {step.bullets.map((item, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <span className="text-red-500">›</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    );
  }
  